import Index from "views/Index.js";
import Login from "views/examples/Login.js";
import DashboardBusiness from "views/examples/DashboardBusiness";
import Players from "views/examples/Players";
import Complaint from "views/examples/Complaint";
import ForgetPassword from "views/examples/ForgetPassword";
import RequestCities from "views/examples/RequestCities";
import RequestedSports from "views/examples/RequestedSports";
import TeamRoster from "views/examples/TeamRoster";
import AdditionalEarning from "views/examples/AdditionalEarning";
import AthletesCalculate from "views/examples/AthletesCalculate";
import ChatRefund from "views/examples/ChatRefund";
import Orders from "views/examples/Orders";
import SuggestionBox from "views/examples/SuggestionBox";
import A4BChat from "views/examples/A4BChat";
import TopicsCount from "views/examples/TopicsCount";
import AthleteEarning from "views/examples/AthleteEarning";
import ResetAthleteSummary from "views/examples/ResetAthleteSummary";
import AthleteAnnualEarning from "views/AthleteAnnualEarning";
import ChatRating from "views/examples/ChatRating";
import Blogs from "views/examples/blogs";
import Resolution from "views/examples/Resolution";
import ResolutionChat from "views/examples/ResolutionChat";
import Manager from "views/examples/Manager";
import ManagerEarning from "views/examples/ManagerEarning";
import Refunds from "views/examples/Refunds";
import RefundDetails from "views/examples/RefundDetails";
import ContractRequests from "views/examples/ContractRequests";
import ContractRequestDetail from "views/examples/ContractRequestDetail";
import AdminDuties from "views/examples/AdminDuties";
import Contest from "views/examples/Contest";
import Organizers from "views/examples/Organizers";
import InstituteRequest from "views/examples/InstituteRequest";
import AddSubAdmin from "views/examples/AddSubAdmin";
import AdminEducation from "views/examples/AdminEducation";
import ApprovedSchools from "views/examples/ApprovedSchools";
import RVRating from "views/examples/RVRating";
import FansData from "views/examples/FansData";
import Schools from "views/examples/Schools";
import Vendors from "views/examples/Vendors";
import Bids from "views/examples/Bids";
import Collectives from "views/examples/Collectives";
import ContactSchools from "views/examples/ContactSchools";
import FansSurvey from "views/examples/FanSurvey";
import Notifications from "views/examples/Notifications";
import Crypto from "views/examples/Crypto";
import NewsletterEmails from "views/examples/NewsletterEmails";
import DistributedCoins from "views/examples/DistributedCoins";
import SportsCommunityBadge from "views/examples/SportsCommunityBadge";
import GasFeeMonitor from "views/examples/GasFeeMonitor";
import VisibilityBoardPayments from "views/examples/VisibilityBoardPayments";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/business",
    name: "Dashboard Business",
    icon: "ni ni-tv-2 text-primary",
    component: DashboardBusiness,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/players",
    name: "Athletes",
    icon: "ni ni-tv-2 text-primary",
    component: Players,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/fans",
    name: "Fans",
    icon: "ni ni-tv-2 text-primary",
    component: FansData,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/fans-survey",
    name: "Fans Survey",
    icon: "ni ni-tv-2 text-primary",
    component: FansSurvey,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-tv-2 text-primary",
    component: Notifications,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/contract-requests",
    name: "Contracts",
    icon: "ni ni-tv-2 text-primary",
    component: ContractRequests,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/contact-schools",
    name: "Contact Schools",
    icon: "ni ni-tv-2 text-primary",
    component: ContactSchools,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/schools",
    name: "Schools",
    icon: "ni ni-tv-2 text-primary",
    component: Schools,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/collectives",
    name: "Collectives",
    icon: "ni ni-tv-2 text-primary",
    component: Collectives,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/approved-schools",
    name: "Approved Schools",
    icon: "ni ni-tv-2 text-primary",
    component: ApprovedSchools,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/institute-requests",
    name: "Institute Request",
    icon: "ni ni-tv-2 text-primary",
    component: InstituteRequest,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/duties",
    name: "Admin Duties",
    icon: "ni ni-tv-2 text-primary",
    component: AdminDuties,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/contract-request/:id",
    name: "",
    icon: "ni ni-tv-2 text-primary",
    component: ContractRequestDetail,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/manager",
    name: "Manager",
    icon: "ni ni-tv-2 text-primary",
    component: Manager,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/manager-earning/:id",
    name: "",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerEarning,
    layout: "/admin",
    isMenu: false,
  },

  {
    path: "/blogs",
    name: "News",
    icon: "ni ni-tv-2 text-primary",
    component: Blogs,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/admin-education",
    name: "Admin Education",
    icon: "ni ni-tv-2 text-primary",
    component: AdminEducation,
    layout: "/admin",
    isMenu: true,
  },

  {
    path: "/complaints",
    name: "Issues",
    icon: "ni ni-tv-2 text-primary",
    component: Complaint,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/gas-fee-monitor",
    name: "Gas Fee Monitor",
    icon: "ni ni-money-coins text-primary",
    component: GasFeeMonitor,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/orders",
    name: "Orders",
    icon: "ni ni-tv-2 text-primary",
    component: Orders,
    layout: "/admin",
    subAdmin: true,
  },
  {
    path: "/a4b-chat",
    name: "A4B Chats",
    icon: "ni ni-tv-2 text-primary",
    component: A4BChat,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/resolution",
    name: "Resolution",
    icon: "ni ni-tv-2 text-primary",
    component: Resolution,
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/chat-ratings",
    name: "Chat ratings",
    icon: "ni ni-tv-2 text-primary",
    component: ChatRating,
    layout: "/admin",
    isMenu: true,
  },
  // {
  //   path: "/a4b-chat-refund",
  //   name: "A4B chat Refund",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: ChatRefund,
  //   layout: "/admin",
  //   isMenu: true,
  // },
  {
    path: "/additional-earnings",
    name: "Additional Earnings",
    icon: "ni ni-tv-2 text-primary",
    component: AdditionalEarning,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/add-sub-admin",
    name: "Add Sub Admin",
    icon: "ni ni-tv-2 text-primary",
    component: AddSubAdmin,
    layout: "/admin",
    isMenu: true,
  },

  {
    path: "/request-cities",
    name: "City Requests",
    icon: "ni ni-tv-2 text-primary",
    component: RequestCities,
    layout: "/admin",
    isMenu: true,
  },
  // {
  //   path: "/rv-rating",
  //   name: "RV Rating",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: RVRating,
  //   layout: "/admin",
  //   isMenu: true,
  // },
  {
    path: "/request-sports",
    name: "Sport Requests",
    icon: "ni ni-tv-2 text-primary",
    component: RequestedSports,
    layout: "/admin",
    isMenu: true,
  },
  // {
  //   path: "/team-roasters",
  //   name: "Team Rosters",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: TeamRoster,
  //   layout: "/admin",
  //   isMenu: true,
  // },
  {
    path: "/topic-chats",
    name: "Topics Chats",
    icon: "ni ni-tv-2 text-primary",
    component: TopicsCount,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/athlete-calculate",
    name: "ADMIN Yearly Earning",
    icon: "ni ni-tv-2 text-primary",
    component: AthletesCalculate,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/refunds",
    name: "Refunds",
    icon: "ni ni-tv-2 text-primary",
    component: Refunds,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/refund-details",
    name: "Refunds-Details",
    icon: "ni ni-tv-2 text-primary",
    component: RefundDetails,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/a4b-suggestion-box",
    name: "A4B Suggestion Box",
    icon: "ni ni-tv-2 text-primary",
    component: SuggestionBox,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
  },

  {
    path: "/forget-password",
    name: "Forget Password",
    icon: "ni ni-circle-08 text-pink",
    component: ForgetPassword,
    layout: "/auth",
  },
  {
    path: "/reset-athlete-summary",
    name: "Reset Athlete Summary",
    icon: "ni ni-circle-08 text-pink",
    component: ResetAthleteSummary,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/players-earning/:id",
    component: AthleteEarning,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/annual-earning/:id",
    component: AthleteAnnualEarning,
    layout: "/public",
    isMenu: false,
  },
  {
    path: "/resolution-chat/:id",
    component: ResolutionChat,
    layout: "/admin",
    isMenu: false,
  },
  {
    path: "/contest",
    component: Contest,
    name: "Contest",
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/organizers",
    component: Organizers,
    name: "Organizers",
    layout: "/admin",
    isMenu: true,
    subAdmin: true,
  },
  {
    path: "/vendors",
    name: "Vendors",
    icon: "ni ni-tv-2 text-primary",
    component: Vendors,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/bids",
    name: "Bids",
    icon: "ni ni-tv-2 text-primary",
    component: Bids,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/coins-stats",
    name: "Coins Stats",
    icon: "ni ni-tv-2 text-primary",
    component: Crypto,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/coins-distribution",
    name: "Coins Distribution",
    icon: "ni ni-tv-2 text-primary",
    component: DistributedCoins,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/newsletter-emails",
    name: "Newsletter Emails",
    icon: "ni ni-tv-2 text-primary",
    component: NewsletterEmails,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/call-community-members",
    name: "Call Community Members",
    icon: "ni ni-tv-2 text-primary",
    component: SportsCommunityBadge,
    layout: "/admin",
    isMenu: true,
  },
  {
    path: "/visibility-board-payments",
    name: "Visibility Board Payments",
    icon: "ni ni-money-coins text-success",
    component: VisibilityBoardPayments,
    layout: "/admin",
    isMenu: true,
  },
];

export default routes;
